import { useEffect } from "react";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { limit, orderBy, query, where } from "firebase/firestore";
import { getSemanticDataCollection } from "~/integrations/firebase/collections/semantic-data";
import { logError } from "~/shared/services/error-reporting";

export const useProductSemanticData = (
  productId: string,
  organisationId: string,
  workId?: string | null,
) => {
  // The product has no pointer to its result, which sits on one format of the work.
  const [values, loading, error] = useCollectionData(
    query(
      getSemanticDataCollection(),
      where("organisation.id", "==", organisationId),
      workId
        ? where("workId", "==", workId)
        : where("productId", "==", productId),
      orderBy("receivedAt", "desc"),
      limit(1),
    ),
  );

  useEffect(() => {
    if (error) logError(error);
  }, [error]);

  const semanticData = values?.[0];
  const matchesCurrentPage = Boolean(
    semanticData &&
      semanticData.organisation.id === organisationId &&
      (workId
        ? semanticData.workId === workId
        : semanticData.productId === productId),
  );

  return {
    semanticData: matchesCurrentPage ? semanticData : undefined,
    loading:
      loading ||
      (!error &&
        (values === undefined || Boolean(semanticData && !matchesCurrentPage))),
    error: error ?? undefined,
  };
};
